module.exports = __webpack_public_path__ + "static/media/inB.4e9f6750.png";